<template>
	<v-dialog
		:value="value"
		persistent
		width="783px"
		@input="sendValue"
	>
		<v-card>
			<v-card-title class="headline py-2 pl-5">
				<v-layout row wrap align-center>
					<v-flex xs3 text-xs-left>
						<p class="headline-title">
							Visualizar reserva
						</p>
					</v-flex>
					<v-flex xs3 text-xs-right pl-0>
						<label class="headline-label">
							Booking ID:
						</label>
						{{ model.numReservation }}
					</v-flex>
					<v-flex xs6 text-xs-right>
						<v-btn
							color="grey"
							icon
							@click="closeBookingModal"
						>
							<v-icon>close</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
			</v-card-title>
			<v-card-text class="px-0">
				<v-layout row wrap px-2>
					<v-flex xs12>
						<div class="bar-data">
							<div class="bar-data-item">
								<p>
									Fecha de reserva:
									<span>{{ model.bookingDate | parseDate }}</span>
								</p>
							</div>
							<div class="bar-data-item">
								<p>
									Llegada:
									<span>{{ model.bookingStart | parseDate }}</span>
								</p>
							</div>
							<div class="bar-data-item">
								<p>
									Salida:
									<span>{{ model.bookingEnd | parseDate }}</span>
								</p>
							</div>
							<div class="bar-data-item">
								<p>
									Noches:
									<span>{{ model.numberNights }}</span>
								</p>
							</div>
							<div class="bar-data-item no-border">
								<p>
									Huésped:
									<span>{{ model.quantity }}</span>
								</p>
							</div>
						</div>
					</v-flex>
				</v-layout>
				<v-layout wrap px-4>
					<v-flex xs2 ml-1>
						<v-btn
							flat
							class="blue--text"
							@click="goToCheckIn(subsidiaryId,model.entityId)"
						>
							Editar Clientes
						</v-btn>
					</v-flex>
				</v-layout>
				<v-layout row wrap mb-2
					text-xs-left px-5>
					<v-flex xs3>
						<label class="modal-label">
							Nº Tarjeta
						</label>
						<p class="modal-text mt-2">{{ getObjectProp(model, 'customer', 'cardVip') }}</p>
					</v-flex>
					<v-flex xs3>
						<label class="modal-label">
							Tipo de identificación
						</label>
						<p class="modal-text mt-2">
							{{ getObjectProp(model, 'customer', 'documentName') }}:
							{{ getObjectProp(model, 'customer', 'numDocument') }}
						</p>
					</v-flex>
					<v-flex xs3>
						<label class="modal-label">
							Apellidos y Nombres
						</label>
						<p class="modal-text mt-2">
							{{ getObjectProp(model, 'customer', 'lastname') }},
							{{ getObjectProp(model, 'customer', 'name') }}
						</p>
					</v-flex>
					<v-flex xs3>
						<label class="modal-label">
							Correo electrónico
						</label>
						<p class="modal-text mt-2">{{ getObjectProp(model, 'customer', 'email') }}</p>
					</v-flex>
				</v-layout>
				<v-layout wrap v-if="model.customerAditional" pl-5 mb-1>
					<label>Huéspedes adicionales:</label>
				</v-layout>
				<v-layout row wrap mb-4
					text-xs-left px-5
					v-for="customerAditional in model.customerAditional"
					:key="customerAditional.id">
					<v-flex xs3>
						<label class="modal-label">
							Tipo de identificación
						</label>
						<p class="modal-text mt-2">
							{{ customerAditional.documentName }}:
							{{ customerAditional.numDocument }}
						</p>
					</v-flex>
					<v-flex xs3>
						<label class="modal-label">
							Apellidos y Nombres
						</label>
						<p class="modal-text mt-2">
							{{ customerAditional.lastname }},
							{{ customerAditional.name }}
						</p>
					</v-flex>
					<v-flex xs3>
						<p class="modal-text mt-4">{{ customerAditional.flagPerson }}</p>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12>
						<v-divider></v-divider>
					</v-flex>
				</v-layout>
				<v-layout row wrap my-4
					text-xs-left px-5
					v-if="model.channel">
					<v-flex xs12 mb-3>
						<label class="modal-label pr-2">Segmento:</label>
						<span class="modal-text">{{ getObjectProp(model, 'channel', 'name') }}</span>
					</v-flex>
					<v-flex xs2 mr-3
						v-for="(value, key) in model.channel.data.questions"
						:key="key">
						<label class="modal-label">
							{{ key }}
						</label>
						<p class="modal-text mt-2">
							{{ value }}
						</p>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-layout row wrap justify-center>
					<v-flex xs2 pr-2>
						<v-btn
							class="btn-cancel grey"
							@click.native="closeBookingModal"
						>
							Cerrar
						</v-btn>
					</v-flex>
					<v-flex xs2 pl-2>
						<v-btn
							class="btn-success white--text"
							@click.native="goToUpdateBooking">
							Editar
						</v-btn>
					</v-flex>
				</v-layout>
			</v-card-actions>
		</v-card>
	</v-dialog>	
</template>
<script>
import { format } from 'date-fns';
import { parseDate, round } from '@/shared/filters';

function getObjectProp(customerData, prop1, prop2) {
	return customerData.customer ? customerData[prop1].data[prop2] : {};
}

function goToUpdateBooking() {
	this.$router.push({
		name: 'booking-edit',
		params: {
			codeBooking: this.model.code,
		},
	});
}

function closeBookingModal() {
	this.$emit('close-modal');
}

function goToCheckIn(hotelId, roomTypeId) {
	const query = {
		initDate: format(this.customerInfo.customer.dateRange[0], 'YYYY-MM-DD'),
		endDate: format(this.customerInfo.customer.dateRange[1], 'YYYY-MM-DD'),
		roomId: this.customerInfo.room.id,
		bookingCode: this.customerInfo.customer.bookingCode,
	};
	this.$router.push({
		name: 'checkin-form-tabs',
		params: {
			hotelId,
			roomTypeId,
		},
		query,
	});
}

function sendValue(value) {
	this.$emit('input', value);
}

export default {
	name: 'menu-visualize',
	inheritAttrs: false,
	filters: {
		parseDate,
		round,
	},
	methods: {
		closeBookingModal,
		getObjectProp,
		goToCheckIn,
		goToUpdateBooking,
		sendValue,
	},
	props: {
		model: {
			default: () => {},
			type: Object,
		},
		value: null,
	},
};
</script>
<style lang="scss" scoped>
.headline {
	border-bottom: 1px solid map-get($colors, border-modal);
	color: map-get($colors, realtime-label);
	font-family: map-get($fonts, regular);
	font-size: map-get($sizes, fourteen) !important;
	text-transform: capitalize;

	&-title {
		color: map-get($colors, default-dark);
		font-size: map-get($sizes, eighteen);
		font-weight: normal;
		margin: 0px;
		text-transform: none;
	}

	&-label {
		color: map-get($colors, bg-chart);
		font-family: map-get($fonts, medium);
	}
}

.bar-data {
	align-items: center;
	background-color: white;
	box-shadow: 0 2px 5px 0 rgba($color: #000000, $alpha: .1);
	display: flex;
	height: 48px;
	justify-content: space-around;

	&-item {
		border-right: 1px solid map-get($colors, year-select);
		flex: 1 auto;

		&:last-of-type {
			border-right: 0px;
		}

		&.no-border {
			border-right: 0px;
		}

		p {
			color: map-get($colors, bg-chart);
			font-family: map-get($fonts, medium);
			font-size: map-get($sizes, fourteen);
			margin-bottom: 0px;

			span {
				color: map-get($colors, realtime-label);
				font-family: map-get($fonts, regular);
				font-size: map-get($sizes, fourteen);
			}
		}
	}

	.bar-icon {
		font-size: map-get($map: $sizes, $key: twenty);
		justify-content: flex-start;
		width: 20px;
	}
}

.btn-cancel {
	&.grey {
		background-color: map-get($colors, tag-menu-span) !important;
	}
}
</style>




// WEBPACK FOOTER //
// MenuVisualize.vue?0a8020cc